import keyMirror from "ramda-extension/es/keyMirror";
export { default as globalErrors } from './globalErrors';
export const fieldStateActions = keyMirror({
    UPDATE_FIELDS_STATE: null,
    SET_ALL_FIELDS_VALID: null
});
export const globalErrorAction = keyMirror({
    UPDATE_GLOBAL_ERRORS: null,
    CLEAR_GLOBAL_ERRORS: null
});
export const formStateActions = keyMirror({
    UPDATE_FORM_STATE: null
});
export const temporaryStoreActions = keyMirror({
    UPDATE_TEMPORARY_STORE: null,
    DELETE_TEMPORARY_STORE: null,
    CLEAR_TEMPORARY_STORE: null
});
export const fileInputActions = keyMirror({
    ADD_FILE_INPUT: null,
    REMOVE_FILE_INPUT: null
});
export const appContextActions = keyMirror({
    UPDATE_ACCESS_TOKEN: null,
    UPDATE_REFRESH_TOKEN: null,
    MERGE_APP_CONTEXT: null,
    CLEAR_APP_CONTEXT: null,
    SET_IS_PENDING: null
});
export const urlsActions = keyMirror({
    MERGE_URLS: null
});
